import { navigate } from "@reach/router";
import { LoadingSpinner } from "components/Loading/LoadingSpinner";
import { useEffect } from "react";

import { getRfxSubmissionByRfxAndCompanyId } from "newui/features/Rfx/Submission/submission-api";

/**
 * redirects from old client urls:
 * 	account/431/request-for-quote/489/submission/130/returnable-schedules
 *  (130 is COMPANYID)
 *
 * to:
 * 	account/431/rfx/489/submission/947/returnable-schedules
 *  (947 is rfxInviteId)
 *
 * redirects from old supplier urls:
 * account/130/request-for-quote/494/returnable-schedules
 *
 * to:
 * account/130/rfx/494/submission/980/returnable-schedules
 *
 * @param param0
 * @returns
 */
const GetRfxSubmissionByCompany: React.FC<{
	companyId?: number;
	currentTab?: string;
	path: string;
	rfxId?: number;
	submissionCompanyId?: number;
}> = ({ companyId, currentTab, rfxId, submissionCompanyId, path }) => {
	useEffect(() => {
		if (!companyId || !rfxId || !submissionCompanyId) {
			navigate("/not-found");
			return;
		}

		getRfxSubmissionByRfxAndCompanyId(rfxId, submissionCompanyId).then(
			(rfxInviteId) => {
				if (!rfxInviteId) {
					navigate(`/account/${companyId}/rfx/${rfxId}/all`);
					return;
				}

				let redirectPath = `/account/${companyId}/rfx/${rfxId}/submission/${rfxInviteId}/`;

				if (currentTab) {
					redirectPath += `${currentTab}/`;
				}

				navigate(redirectPath, {
					replace: true,
				});
			}
		);
	}, [companyId, currentTab, rfxId, submissionCompanyId]);

	return (
		<div className="flex-auto">
			<LoadingSpinner label={"Loading, Please Wait..."} />
		</div>
	);
};

export default GetRfxSubmissionByCompany;
